import React from 'react';
import { EVENT_PHASE_LABELS } from '../lib/event-status';
import type { EventPhase } from '../lib/event-status';

const PHASE_CLASSES: Record<EventPhase, string> = {
  planned: 'bg-light text-dark border',
  upcoming: 'bg-primary',
  soon: 'bg-warning text-dark',
  now: 'bg-success',
  finished: 'bg-secondary',
};

type Props = {
  phase: EventPhase;
  className?: string;
};

const EventPhaseBadge: React.FC<Props> = ({ phase, className = '' }) => (
  <span className={`badge ${PHASE_CLASSES[phase]} ${className}`.trim()}>
    {EVENT_PHASE_LABELS[phase]}
  </span>
);

export default EventPhaseBadge;
